import {Model} from './Model';
import {Property} from './Property';

export class Collection {
  static TYPE_PRODUCTION = 'production';
  static TYPE_STOCK = 'stock';

  public id: number;
  public name: string;
  public modelLabel: string;
  public productLabel: string;
  /** Carpets: overrides the Carpet Size row label, same mechanism as modelLabel/productLabel (FR-027) */
  public sizeLabel: string;
  public status: string;
  public type: string = Collection.TYPE_PRODUCTION;
  public modelCount: number;
  public models: Model[];
  public translations: any;
  public properties?: Property[] = [];
  public fabrics = [];
  public separateDeliveryAddress = false;
  public deliveryCostPerArticle?: number;
  public endCustomerDelivery = false;
  public primaryDeliveryAddress = false;
  public dealerDeliveryCostPerArticle?: number;

  constructor() {
    this.translations = [];
  }
}
